import { connectCustom } from "@client/lib/misc";
import { getColorSelector, getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState, type EntityRef } from "@client/types";
import { type WithChildren } from "@client/types/WithChildren";
import Component, { type ActionProps, type MapProps } from "./component";
import { makeBodyStyleSelector, makeStyleSelector } from "./selectors";

const INVISIBLE_PROPS: MapProps = {
  children: null,
  bodyStyle: {},
  isVisible: false,
  overlayColor: "",
  style: {},
  width: ""
};

export type PopupProps = EntityRef &
  WithChildren & {
    heading?: any;
    footer?: any;
    isVisible: boolean;
    onClose: () => void;
  };

export const makePopup = (target: string, prefix?: string) => {
  const makeMapStateToProps = () => {
    const bodyStyleSelector = makeBodyStyleSelector(target, prefix);
    const overlayColorSelector = getColorSelector(target, "overlayColor", prefix);
    const styleSelector = makeStyleSelector(target, prefix);
    const widthSelector = getSettingValueSelector(target, "width", prefix);

    return (state: AppState, props: PopupProps): MapProps => {
      if (!props.isVisible) return INVISIBLE_PROPS;

      return {
        ...props,
        bodyStyle: bodyStyleSelector(state, props),
        isVisible: true,
        overlayColor: overlayColorSelector(state, props),
        style: styleSelector(state, props),
        width: widthSelector(state, props)
      };
    };
  };

  const mapDispatchToProps = (dispatch, props: PopupProps): ActionProps => ({
    onClose: props.onClose
  });

  return connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
};

const Popup = makePopup(TargetSelector.Entity, "popup");
export default Popup;
